import {createAction, props} from '@ngrx/store'

export const SOURCE = '[Lpis User Subject Search]'

export const setItemCollection = createAction(
    `${SOURCE} SetItemCollection`, props<{ itemCollection: any[] }>(),
)
export const setFilterCriteria = createAction(
    `${SOURCE} SetFilterCriteria`, props<{ filterCriteria: any }>(),
)
export const updateFilterCriteria = createAction(
    `${SOURCE} UpdateFilterCriteria`, props<{ criteriaFragment: any }>(),
)
export const resetState = createAction(
    `${SOURCE} ResetState`,
)
export const noAction = createAction(
    `${SOURCE} No Action`,
)
export const resetSearch = createAction(
    `${SOURCE} ResetSearch`,
)
export const setLpisId = createAction(
    `${SOURCE} SetLpisId`, props<{ lpisId: number }>(),
)
export const toggleExceptLpisId = createAction(
    `${SOURCE} ToggleExceptLpisId`, props<{ lpisId: number }>(),
)
export const resetFilterCriteria = createAction(
    `${SOURCE} ResetFilterCriteria`,
)
export const resetItemCollection = createAction(
    `${SOURCE} ResetItemCollection`,
)
export const resetLpisId = createAction(
    `${SOURCE} ResetLpisId`,
)
